<template>
  <div>
    <editor-menu-bar :editor="editor">
      <div class="menubar" slot-scope="{ commands, isActive }">
        <b-button-group>
          <b-button :pressed="isActive.bold()" @click="commands.bold">
            <i class="material-icons">format_bold</i>
          </b-button>
          <b-button :pressed="isActive.italic()" @click="commands.italic">
            <i class="material-icons">format_italic</i>
          </b-button>
          <b-button :pressed="isActive.strike()" @click="commands.strike">
            <i class="material-icons">format_strikethrough</i>
          </b-button>
          <b-button :pressed="isActive.underline()" @click="commands.underline">
            <i class="material-icons">format_underlined</i>
          </b-button>
          <b-button :pressed="isActive.paragraph()" @click="commands.paragraph">
            P
          </b-button>
          <b-button
            :pressed="isActive.heading({ level: 1 })"
            @click="commands.heading({ level: 1 })"
          >
            H1
          </b-button>
          <b-button
            :pressed="isActive.heading({ level: 2 })"
            @click="commands.heading({ level: 2 })"
          >
            H2
          </b-button>
          <b-button
            :pressed="isActive.heading({ level: 3 })"
            @click="commands.heading({ level: 3 })"
          >
            H3
          </b-button>
          <b-button
            :pressed="isActive.bullet_list()"
            @click="commands.bullet_list"
          >
            <i class="material-icons">format_list_bulleted</i>
          </b-button>
          <b-button
            :pressed="isActive.ordered_list()"
            @click="commands.ordered_list"
          >
            <i class="material-icons">format_list_numbered</i>
          </b-button>
          <b-button
            :pressed="isActive.blockquote()"
            @click="commands.blockquote"
          >
            <i class="material-icons">format_quote</i>
          </b-button>
          <b-button @click="commands.undo">
            <i class="material-icons">undo</i>
          </b-button>
          <b-button @click="commands.redo">
            <i class="material-icons">redo</i>
          </b-button>
        </b-button-group>
      </div>
    </editor-menu-bar>
    <div class="form-control h-auto mt-2">
      <editor-content :editor="editor" class="gid-rich-text-tiptap" />
    </div>
  </div>
</template>

<script>
import { Editor, EditorContent, EditorMenuBar } from 'tiptap';
import {
  Blockquote,
  HardBreak,
  Heading,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Italic,
  Link,
  Strike,
  Underline,
  History,
} from 'tiptap-extensions';

export function stripHtml(html) {
  let tmp = document.createElement('DIV');
  tmp.innerHTML = html;
  let text = tmp.textContent || tmp.innerText || '';
  return text.trim();
}

export default {
  props: {
    value: String,
  },
  components: {
    EditorContent,
    EditorMenuBar,
  },
  data() {
    return {
      editor: null,
    };
  },
  mounted() {
    this.editor = new Editor({
      extensions: [
        new Blockquote(),
        new BulletList(),
        new HardBreak(),
        new Heading({ levels: [1, 2, 3] }),
        new ListItem(),
        new OrderedList(),
        new TodoItem(),
        new TodoList(),
        new Bold(),
        new Italic(),
        new Link(),
        new Strike(),
        new Underline(),
        new History(),
      ],
      disablePasteRules: true,
      disableInputRules: true,
      content: this.value,
      onUpdate: ({ getHTML }) => {
        const html = getHTML();
        this.$emit('input', stripHtml(html) == '' ? null : html);
      },
    });
  },
  beforeDestroy() {
    this.editor.destroy();
  },
};
</script>

<style lang="scss">
.gid-rich-text-tiptap .ProseMirror:focus {
  outline: none;
}
</style>
